import { IInvestment, } from "../schemas/entity_set";
import { IModelService, IModelFilter, IRequestResult } from "../schemas/structure"

interface IInvestmentFilter extends IModelFilter { }

interface IInvestmentService extends IModelService<IInvestment> {
    compute(id: number): angular.IPromise<IRequestResult<any>>
    apply(id: number): angular.IPromise<IRequestResult<any>>
    distributionPreview(id: number): angular.IPromise<IRequestResult<string>>
    query(params: IInvestmentFilter): angular.IPromise<IRequestResult<Array<IInvestment>>>
}

class InvestmentService implements IInvestmentService {

    static $inject = ["$q", "$http", "BASEAPI", "$uibModal"];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string,
        private $uibModal: angular.ui.bootstrap.IModalService) { }

    get() {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/investment`).then((response: IRequestResult<Array<IInvestment>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    find(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/investment?id=${id}`).then((response: IRequestResult<IInvestment>) => {
            defer.resolve(response)
        })
        return defer.promise
    }
    
    distributionPreview(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/investment/interestdistribution?id=${id}`).then((response: IRequestResult<string>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    compute(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/investment/computeinterest?id=${id}`).then((response: IRequestResult<any>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    apply(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/investment/applyinterest?id=${id}`).then((response: IRequestResult<any>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    query(params: IInvestmentFilter) {
        let defer = this.$q.defer()
        this.$http.post(`${this.baseUrl}/investment/query`, params).then((response: IRequestResult<Array<IInvestment>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    save(investment: IInvestment) {
        let defer = this.$q.defer()
        if (investment.id) {
            this.$http.put(`${this.baseUrl}/investment`, investment).then((response: IRequestResult<IInvestment>) => {
                defer.resolve(response)
            })
        } else {
            this.$http.post(`${this.baseUrl}/investment`, investment).then((response: IRequestResult<IInvestment>) => {
                defer.resolve(response)
            })
        }
        return defer.promise
    }

    delete(id: number) {
        let defer = this.$q.defer()
        this.$http.delete(`${this.baseUrl}/investment?id=${id}`).then((response: IRequestResult<IInvestment>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

}

export { InvestmentService, IInvestmentService, IInvestmentFilter }


// WEBPACK FOOTER //
// ./app/investments/investment_service.ts